export default __webpack_public_path__ + "static/media/docker.d89a9146.svg";